const LEAD_TRACK_COOKIE_NAME = "_ldat";
const GOOGLE_COOKIE_NAME = "_ga";
const DOMAIN_URL = "aprovatotal.com.br";
const EXPIRATION_DAYS_COOKIE = 730;

interface LeadData {
  userIdCookie: string;
  gaCookie: string;
  url: string;
  page: string;
  device: string;
  screenWidth: number | null;
  screenHeight: number | null;
  windowInnerWidth: number | null;
  windowInnerHeight: number | null;
  platform: string;
  [key: string]: any;
}

async function mountLead(): Promise<LeadData> {
  let userIdCookie = getCookie(LEAD_TRACK_COOKIE_NAME);
  if (!userIdCookie) {
    userIdCookie = setID();
  }

  const params = await getParams();

  return {
    userIdCookie,
    gaCookie: getCookie(GOOGLE_COOKIE_NAME),
    url: getUrl(),
    page: getPathUrl(),
    ...params,
    device: getDeviceType(),
    ...getScreenAndWindowInfo()
  };
}

function getCookie(cookieName: string): string {
  try {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  } catch (e) {
    return "";
  }
}

function setID(): string {
  const guid = getGuid();
  const expires = 60 * 60 * 24 * EXPIRATION_DAYS_COOKIE;
  document.cookie = `${LEAD_TRACK_COOKIE_NAME}=${guid}; max-age=${expires}; domain=${DOMAIN_URL};`;
  return guid;
}

function getGuid(): string {
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

function getPathUrl(): string {
  return document.location.pathname;
}

function getUrl(): string {
  return `${document.location.origin}${getPathUrl()}`;
}

async function getParams(): Promise<{ [key: string]: string }> {
  const urlSearch = new URLSearchParams(window.location.search);
  return {
    source: urlSearch.get("source") || "",
    channel: urlSearch.get("channel") || "",
    seller: urlSearch.get("seller") || "",
    origin: document.referrer || "",
    utmSource: urlSearch.get("utm_source") || "",
    utmMedium: urlSearch.get("utm_medium") || "",
    utmCampaign: urlSearch.get("utm_campaign") || "",
    utmContent: urlSearch.get("utm_content") || "",
    utmTerm: urlSearch.get("utm_term") || "",
    gclid: urlSearch.get("gclid") || "",
    ip: await getIP() || ""
  };
}

function getDeviceType(): string {
  const userAgent = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
    return "mobile";
  }
  return "desktop";
}

function getScreenAndWindowInfo(): {
  screenWidth: number | null;
  screenHeight: number | null;
  windowInnerWidth: number | null;
  windowInnerHeight: number | null;
  platform: string;
} {
  return {
    screenWidth: window.screen?.width ?? null,
    screenHeight: window.screen?.height ?? null,
    windowInnerWidth: window.innerWidth || null,
    windowInnerHeight: window.innerHeight || null,
    platform: navigator.platform || ""
  };
}

async function getIP(): Promise<string> {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    if (!response.ok) {
      return "";
    }
    const data = await response.json();
    return data.ip;
  } catch (error) {
    return "";
  }
}

async function sendLead(data: LeadData): Promise<LeadData> {
  const requestConfig = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  await fetch("https://tracking-fv7tv3cf4a-uc.a.run.app", requestConfig);
  return data;
}

export default async function TrackEventsUser(eventName: string, platformVersion: string): Promise<LeadData | undefined> {
  try {
    const returnObj = await mountLead();

    if (eventName) {
      returnObj.event = eventName;
    }

    if (platformVersion) {
      returnObj.platformVersion = platformVersion;
    }

    return sendLead(returnObj);
  } catch (error) {
    console.error("Error on track event", error);
    return undefined;
  }
}
